export default Object.freeze({
  Low: 'low',
  Normal: 'normal',
  High: 'high',
});
